import React from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Content from '../sections/Customize-Cake-Details/Content';
import { Helmet } from "react-helmet";

export default function CustomizeCakeDetails() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme">
            {/* title   */}
            <Helmet>
                <title>Customised Cake Order&apos;s Details</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end  */}

            <main className="body-content">

                {/* Topnavigation start  */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content />
                {/* page content end  */}

            </main>

        </div>
    );
};


